module.exports = __webpack_public_path__ + "static/yosemite-8e4daafa5dce37c1238c4fa22e9c32c5.jpg";